import { z } from 'zod';
import { QuoteToolPreselectedModes } from '@lx/shared/utils/enums';

/**
 * Schema for representing the parameters of the Junior Camp deep link.
 * It is a Zod object schema where we define the required and optional parameters.
 * It is used to validate the parameters of the Junior Camp deep link.
 */
export const JuniorCampDeepLinkParametersSchema = z
  .object({
    preselectedMode: z.enum(QuoteToolPreselectedModes),
    schoolCode: z.string(),
    packageCode: z.string(),
    duration: z.number().min(1),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    optOutProductCode: z.string(),
    optOutProductInfo: z.string(),
  })
  .partial()
  .required({
    preselectedMode: true,
    schoolCode: true,
    packageCode: true,
    duration: true,
    startDate: true,
    endDate: true,
  });
